// extracted by extract-css-chunks-webpack-plugin
module.exports = {"itemPriceData":"zfqz0","shopTheLookContainer":"_3-W6v"};